import { useLingui } from "@lingui/react/macro";

import { cn } from "@/shared/lib";

import type { DrillAnswer, DrillSpec } from "../../model/Drill";
import { useOptionView } from "./useOptionView";

type OrderTableProps = {
  spec: DrillSpec;
  answer: DrillAnswer;
  // Подписи колонок: что расставляли, значение у сильных и у тебя; формат значения.
  nameLabel: string;
  typicalLabel: string;
  mineLabel: string;
  format: (value: number) => string;
};

// Верный порядок после ответа: место, вариант, значение у сильных, твоё и куда его
// поставил ты.
// На узком экране таблица прокручивается вбок внутри блока.
export const OrderTable = ({
  spec,
  answer,
  nameLabel,
  typicalLabel,
  mineLabel,
  format,
}: OrderTableProps) => {
  const { t } = useLingui();
  const view = useOptionView();
  const byId = new Map(spec.options.map((option) => [option.id, option]));
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[480px] text-left text-sm">
        <thead className="text-xs text-subtle">
          <tr>
            <th className="w-8 py-1 font-normal">#</th>
            <th className="py-1 font-normal">{nameLabel}</th>
            <th className="py-1 font-normal">{typicalLabel}</th>
            <th className="py-1 font-normal">{mineLabel}</th>
            <th className="py-1 font-normal">{t`Your answer`}</th>
          </tr>
        </thead>
        <tbody>
          {spec.correct_ids.map((id, index) => {
            const option = byId.get(id);
            if (option === undefined) {
              return null;
            }
            const placed = answer.option_ids.indexOf(id);
            return (
              <tr key={id} className="border-t border-sidebar-active">
                <td className="py-1.5 font-mono text-accent">{index + 1}</td>
                <td className="py-1.5">{view(option).name}</td>
                <td className="py-1.5 font-mono">
                  {option.value == null ? "—" : format(option.value)}
                </td>
                <td className="py-1.5 font-mono">
                  {option.mine_value == null ? t`not bought` : format(option.mine_value)}
                </td>
                <td className={cn("py-1.5 font-mono", placed === index ? "text-good" : "text-bad")}>
                  {placed < 0 ? "—" : `${placed === index ? "✓" : "✗"} ${placed + 1}`}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
